
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/base/TopNavigation';
import BottomNavigation from '../../components/base/BottomNavigation';
import FamilyCard from '../../components/feature/FamilyCard';

export default function HomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const familyFeatures = [
    {
      title: t('familyCalendar'),
      icon: 'ri-calendar-2-fill',
      description: 'تنظيم المواعيد والأحداث المهمة',
      path: '/calendar',
      bgImage: 'https://public.readdy.ai/ai/img_res/3887ee393fabf2b0e24ffbb300e87aae.jpg'
    },
    {
      title: t('sharedLists'),
      icon: 'ri-list-check-2',
      description: 'قوائم التسوق والمهام المشتركة',
      path: '/lists',
      bgImage: 'https://readdy.ai/api/search-image?query=Shopping%20list%20and%20task%20management%20interface%2C%20organized%20checklist%2C%20family%20planning%2C%20clean%20design%2C%20productivity%20tools%2C%20soft%20colors&width=400&height=200&seq=8&orientation=landscape'
    },
    {
      title: t('messaging'),
      icon: 'ri-message-3-fill',
      description: 'تواصل مع أفراد العائلة',
      path: '/messages',
      bgImage: 'https://readdy.ai/api/search-image?query=Family%20chat%20interface%2C%20messaging%20app%20design%2C%20communication%20platform%2C%20modern%20UI%2C%20warm%20colors%2C%20family%20connection&width=400&height=200&seq=9&orientation=landscape'
    },
    {
      title: t('mediaLibrary'),
      icon: 'ri-gallery-fill',
      description: 'مشاركة الصور والذكريات',
      path: '/gallery',
      bgImage: 'https://readdy.ai/api/search-image?query=Photo%20gallery%20interface%2C%20family%20memories%2C%20image%20collection%2C%20modern%20design%2C%20warm%20lighting%2C%20photo%20sharing%20platform&width=400&height=200&seq=10&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      <TopNavigation title={t('appName')} />
      
      <div className="pt-16 pb-24 px-4">
        {/* Welcome Banner */}
        <div className="relative bg-gradient-to-r from-[#5B9BD5] to-[#4A90C2] rounded-2xl p-6 mb-6 overflow-hidden">
          <div className="flex items-start justify-between">
            <div className="flex-1 pr-4">
              <h1 className="text-2xl font-bold text-white mb-2">{t('welcomeFamily')}</h1>
              <p className="text-blue-100 text-sm">تطبيق إدارة شؤون العائلة</p>
            </div>
            <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-home-heart-fill text-white text-2xl"></i>
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-3 gap-3 mb-6">
          <div className="bg-white rounded-xl p-4 text-center shadow-sm">
            <div className="text-2xl font-bold text-[#5B9BD5] mb-1">3</div>
            <div className="text-xs text-gray-600">أحداث اليوم</div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center shadow-sm">
            <div className="text-2xl font-bold text-[#F4A261] mb-1">12</div>
            <div className="text-xs text-gray-600">مهام معلقة</div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center shadow-sm">
            <div className="text-2xl font-bold text-[#81C784] mb-1">8</div>
            <div className="text-xs text-gray-600">صور جديدة</div>
          </div>
        </div>

        {/* Family Features Grid */}
        <div className="space-y-4">
          {familyFeatures.map((feature, index) => (
            <FamilyCard
              key={index}
              title={feature.title}
              icon={feature.icon}
              description={feature.description}
              bgImage={feature.bgImage}
              onClick={() => navigate(feature.path)}
            />
          ))}
        </div>

        {/* Recent Activity */}
        <div className="mt-6 bg-white rounded-2xl p-4 shadow-sm">
          <h3 className="text-lg font-bold text-gray-800 mb-4">النشاط الأخير</h3>
          <div className="space-y-3">
            <div className="flex items-center">
              <div className="w-8 h-8 bg-[#81C784]/20 rounded-full flex items-center justify-center ml-3">
                <i className="ri-check-line text-[#81C784]"></i>
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-800">أحمد أكمل مهمة "شراء الخضار"</p>
                <p className="text-xs text-gray-500">منذ 5 دقائق</p>
              </div>
            </div>
            <div className="flex items-center">
              <div className="w-8 h-8 bg-[#F4A261]/20 rounded-full flex items-center justify-center ml-3">
                <i className="ri-calendar-line text-[#F4A261]"></i>
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-800">فاطمة أضافت حدث "عشاء العائلة"</p>
                <p className="text-xs text-gray-500">منذ ساعة</p>
              </div>
            </div>
            <div className="flex items-center">
              <div className="w-8 h-8 bg-[#5B9BD5]/20 rounded-full flex items-center justify-center ml-3">
                <i className="ri-image-line text-[#5B9BD5]"></i>
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-800">سارة شاركت 3 صور جديدة</p>
                <p className="text-xs text-gray-500">منذ ساعتين</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
